import React, { useContext, useEffect, useState } from "react";

import Navbar from "../components/Navbar";

import { useLocation } from "react-router-dom";
import { UserContext } from "../hooks/UserContext";
import Loader from "../components/Loader";
import UserService from "../services/User.service";

const MainLayout = ({ children }) => {
  console.debug("MainLayout rendered");

  const { currentUser } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);

  const [profileData, setProfileData] = useState("");

  useEffect(() => {
    if (currentUser && currentUser.email) {
      UserService.getProfile()
        .then((response) => {
          setProfileData(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(error.message);
          setIsLoading(false);
        });
    }
  }, [currentUser]);

  const location = useLocation();
  const showNavbar = [
    "/home",
    "/rewards",
    "/rewards/users",
    // "/banners",
    "/reports",
    "/history",
    "/groups",
    "/users",
    "/redeem",
    "/rewards/history",
    // "/anouncements",
  ].includes(location.pathname);

  const [isToggle, setToggle] = useState(true);
  const sidebarToggle = () => {
    setToggle(!isToggle);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div
          className={
            isToggle
              ? "main-wrapper mini-sidebar expand-menu"
              : "main-wrapper mini-sidebar "
          }
        >
          {showNavbar && (
            <Navbar onToggle={sidebarToggle} profileData={profileData} />
          )}
          {children}
        </div>
      )}
    </>
  );
};

export default MainLayout;
